<template>
  <component
    :is="component"
    v-if="component && rtcSessionFacade"
    :rtc-session-facade="rtcSessionFacade"
  />
</template>

<script lang="ts" setup>
import { closeDialogKey, safeInject } from '@wui/common-library'
import { computed, watch } from 'vue'

import { useCallRingingStore } from '@/app/store/calls/ringing'

import {
  CallingDialog,
  FailedCallDialog,
  InitialDialog,
} from '@/shared/components/dialogs'
import { STATE, useWebRTC } from '@/shared/services/jssip'

const props = defineProps<{
  sessionId: string;
}>()

const { getRTCSessionFacadeById } = useWebRTC()
const closeDialog = safeInject(closeDialogKey)
const rtcSessionFacade = computed(() => getRTCSessionFacadeById(props.sessionId))

if (!rtcSessionFacade.value) {
  closeDialog(undefined)
}

const state = computed(() => {
  return rtcSessionFacade.value?.sessionState.value
})

const component = computed(() => {
  switch (state.value) {
  case STATE.INITIAL: return InitialDialog
  case STATE.PROGRESS:
  case STATE.RINGING: return CallingDialog
  case STATE.ERROR:
  case STATE.UNAVAILABLE:
  case STATE.REJECTED:
  case STATE.BUSY:
  case STATE.OFFLINE: return FailedCallDialog
  default: return undefined
  }
})

watch(state, (newState) => {
  if (!newState || state.value === STATE.CANCELED) {
    useCallRingingStore().deleteBySessionId(props.sessionId)
    closeDialog(true)
  }
})
</script>
